export const EmergencyContact = (props: any) => {
  const { contact_name, contact_number, contact_relationship, city, locality } =
    props;
  return (
    <div className="col-sm-6 px-4">
      <h6 className="mt-4 mb-0">Emergency Contact</h6>
      <table className="table table-striped border-0 mt-2">
        <tbody>
          <tr>
            <th scope="row">Name:</th>
            <td>{contact_name || "-"}</td>
          </tr>
          <tr>
            <th scope="row">Contact Number:</th>
            <td>{contact_number || "-"}</td>
          </tr>
          <tr>
            <th scope="row">Relationship:</th>
            <td>{contact_relationship || "-"}</td>
          </tr>
          <tr>
            <th scope="row">City:</th>
            <td>{city || "-"}</td>
          </tr>
          <tr>
            <th scope="row">Locality:</th>
            <td>{locality || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
